import axios from "@/inside/axios";
import Thematic from "@/inside/models/Text/Thematic";
import ThematicTree from "@/inside/models/Text/ThematicTree";

export default {
    actions: {
        /**
         * Initializes store module by fetching thematics tree from Echoline API.
         *
         * @param {Function} commit
         * @param {array} getters
         * @return {Promise<Readonly<Thematic[]>,object>}
         */
        init({commit, rootGetters, getters}) {
            return new Promise((resolve, reject) => {
                axios.get("/thematics", {
                    validateStatus: status => status === 200,
                    headers: {
                        "Accept-Language": rootGetters["user/get"].language
                    }
                }).then((response) => {
                    commit("set", ThematicTree.fromAPI(response.data));
                    resolve(getters["tree"]);
                }).catch((error) => {
                    reject(error);
                });
            });
        }
    },
    getters: {
        /**
         * Returns a new thematics tree that only contains thematics with ID included in given `filtered_thematic_ids`.
         *
         * Returned `Thematic` instances are **cloned**.
         *
         * @param {Object} state
         * @return {Function(string[]): Readonly<Thematic[]>}
         */
        filteredTree(state) {
            return (filtered_thematic_ids) => {
                const out = [];

                state.thematics.tree.forEach((thematic) => {
                    let filteredChildren = thematic.filterChildren(filtered_thematic_ids);

                    if (filtered_thematic_ids.includes(thematic.id) || filteredChildren.length > 0) {
                        const clone = Object.assign(new Thematic(), thematic);
                        clone.children = filteredChildren.map((child) => {
                            child.parent = clone;
                            return Object.freeze(child);
                        });

                        out.push(Object.freeze(clone));
                    }
                });

                return Object.freeze(out);
            };
        },
        /**
         * Returns any `Thematic` instance corresponding to given `thematic_id` in thematics tree.
         *
         * @param {Object} state
         * @return {Function(string): Thematic|null}
         */
        one(state) {
            return (thematic_id) => {
                return state.thematics.findOne(thematic_id);
            };
        },
        /**
         * Returns thematics tree from module state.
         *
         * @param {Object} state
         * @return {Readonly<Thematic[]>}
         */
        tree(state) {
            return state.thematics.tree;
        }
    },
    mutations: {
        /**
         * @param {Object} state
         * @param {ThematicTree} payload
         */
        set(state, payload){
            state.thematics = payload;
        }
    },
    namespaced: true,
    state: {
        thematics: new ThematicTree(),
    }
}
